import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/DashboardReportChartMembership'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class DashboardReportChartMembershipStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "DashboardReportChartMembershipStore",
			variables: true,
		})
	}
}

export async function load_DashboardReportChartMembership(params) {
  await initClient()

	const store = new DashboardReportChartMembershipStore()

	await store.fetch(params)

	return {
		DashboardReportChartMembership: store,
	}
}
